// Favourites are kept on this device, one list of event ids per guide (see favourites_controller.js)

export function favouritesKey(guideSlug) {
  return `favourites-${guideSlug}`
}

export function readFavourites(guideSlug) {
  try {
    const ids = JSON.parse(localStorage.getItem(favouritesKey(guideSlug))) || []
    return ids.map(Number).filter(Boolean)
  } catch (error) {
    return []
  }
}
